/** 콘솔 페이지 공용 UI 조각 (PC 데스크탑 톤) */
import styled from 'styled-components';

export const PageHead = styled.div`
  display: flex; align-items: flex-end; justify-content: space-between;
  margin-bottom: 22px; gap: 16px;
`;

export const PageTitle = styled.div`
  h2 { font-size: 22px; font-weight: 800; color: #111827; }
  p { font-size: 13px; color: #9CA3AF; margin-top: 5px; }
`;

export const Card = styled.section`
  background: #fff; border: 1px solid #EAEDF3; border-radius: 14px;
  padding: ${({ $pad }) => $pad || '20px'};
`;

export const PrimaryBtn = styled.button`
  display: inline-flex; align-items: center; gap: 7px;
  padding: 10px 18px; background: #4A7CFE; color: #fff;
  border-radius: 9px; font-size: 14px; font-weight: 700;
  &:hover { background: #3B6DE8; }
  &:disabled { opacity: 0.5; cursor: default; }
`;

export const GhostBtn = styled.button`
  display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; flex-shrink: 0;
  padding: 9px 16px; background: #fff; color: #374151;
  border: 1px solid #E2E5EA; border-radius: 9px; font-size: 13px; font-weight: 600;
  &:hover { background: #F9FAFB; }
`;

export const Table = styled.table`
  width: 100%; border-collapse: collapse;
  th, td { text-align: left; padding: 13px 16px; font-size: 14px; }
  thead th {
    font-size: 12px; font-weight: 700; color: #9CA3AF; letter-spacing: 0.02em;
    border-bottom: 1px solid #EAEDF3; background: #FAFBFC;
  }
  tbody td { border-bottom: 1px solid #F1F3F7; color: #374151; }
  tbody tr:hover td { background: #FBFCFE; }
  tbody tr:last-child td { border-bottom: none; }
`;

export const Empty = styled.div`
  padding: 56px 20px; text-align: center; color: #9CA3AF; font-size: 14px;
`;

export const IconBtn = styled.button`
  padding: 6px; border-radius: 7px; color: ${({ $danger }) => ($danger ? '#EF4444' : '#6B7280')};
  &:hover { background: ${({ $danger }) => ($danger ? '#FEF2F2' : '#F3F4F6')}; }
`;

/* ── 통계 카드 ── */
export const StatGrid = styled.div`
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 24px;
  @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
`;

export const StatCard = styled.div`
  background: #fff; border: 1px solid #EAEDF3; border-radius: 14px; padding: 20px;
  display: flex; align-items: center; gap: 16px;
`;

export const StatIcon = styled.div`
  width: 48px; height: 48px; border-radius: 12px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: ${({ $c }) => `${$c}15`}; color: ${({ $c }) => $c};
`;

export const StatBody = styled.div`
  .v { font-size: 24px; font-weight: 800; color: #111827; line-height: 1.1; }
  .l { font-size: 13px; color: #6B7280; margin-top: 4px; }
`;

/* ── 모달 ── */
export const Overlay = styled.div`
  position: fixed; inset: 0; background: rgba(17,24,39,0.45);
  display: flex; align-items: center; justify-content: center; z-index: 100; padding: 20px;
`;

export const Modal = styled.div`
  background: #fff; border-radius: 16px; width: 100%; max-width: ${({ $w }) => $w || '440px'};
  max-height: 88vh; overflow-y: auto;
`;

export const ModalHead = styled.div`
  padding: 16px 20px; background: #EEF2FF; border-bottom: 1px solid #D9E2FF;
  border-radius: 16px 16px 0 0;
  font-size: 15px; font-weight: 800; color: #1E3A5F;
  display: flex; align-items: center; justify-content: space-between;
`;

export const ModalBody = styled.div` padding: 20px; `;
export const ModalFoot = styled.div`
  padding: 14px 20px; border-top: 1px solid #F1F3F7;
  display: flex; gap: 10px; justify-content: flex-end;
`;

export const Field = styled.label`
  display: block; margin-bottom: 14px;
  .lab { display: block; font-size: 13px; font-weight: 700; color: #374151; margin-bottom: 7px; }
  input, select, textarea {
    width: 100%; padding: 11px 13px; border: 1px solid #E2E5EA; border-radius: 9px;
    font-size: 14px; color: #111827;
    &:focus { border-color: #4A7CFE; outline: none; }
  }
  textarea { resize: vertical; min-height: 80px; }
`;
